import React from 'react';
import { useTranslate } from 'react-admin';

import Grid from '@material-ui/core/Grid';

import { TextField, AmountField, BooleanField, GlTypeLabel } from '~/components';
import { TextField as RaTextField } from '~/components/ra';
import { l } from '~/resources/pricings/PricingShow';
import { useDiffClassFor } from '~/hooks/useDraftDiffContext';
import { Longdash, getDateFromDayNumber } from '~/utils';
import { billingDateFormat } from '../Forms/MembershipFeeForm';
import { useAccountEntity } from '~/hooks/accounts';

const MembershipFeeView = (props: { record: any }) => {
  const { record } = props;
  const translate = useTranslate();
  const t = (key: string, variant: number = 1): string => translate(l(key), variant);
  const { data: pnlAccount } = useAccountEntity(record.pnlAccountId);
  const diffClass = useDiffClassFor();

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={4}>
        <TextField label={t('type')} className={diffClass('type')}>
          {record.type && t(record.type)}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        <TextField label={t('statementTitle')} className={diffClass('name')}>
          {record.name}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        {record.pnlAccountId ? (
          <TextField label={t('pnlAccount')} ellipsis className={diffClass('pnlAccountId')}>
            <GlTypeLabel glType={pnlAccount?.glType} text={pnlAccount?.alias} />
          </TextField>
        ) : (
          <RaTextField label={t('pnlAccount')} allowEmpty />
        )}
      </Grid>
      <Grid item xs={4}>
        <TextField label={t('amount')} className={diffClass('amount')}>
          <AmountField amount={record.amount} />
        </TextField>
      </Grid>
      <Grid item xs={4}>
        <TextField label={t('period')} className={diffClass('period')}>
          {record.period && t(record.period)}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        <TextField label={t('billingDate')} className={diffClass('billingDate')}>
          {record.billingDate
            ? record.period === 'annually'
              ? getDateFromDayNumber(record.billingDate).format(billingDateFormat)
              : record.billingDate
            : Longdash}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        <BooleanField
          label={t('payOnTheFirstCalendarMonth')}
          value={record.payOnTheFirstCalendarMonth}
          className={diffClass('payOnTheFirstCalendarMonth')}
        />
      </Grid>
      {(record.index || record.index === 0) && (
        <Grid item xs={4}>
          <TextField label={t('index')}>{record.index}</TextField>
        </Grid>
      )}
    </Grid>
  );
};

export default MembershipFeeView;
